import { responseNotification } from "../../utils/notify";
import { LOGIN_REQUEST, LOGIN_SUCCESS } from "./authType";

//  login action here
export const login = async (dispatch, { email, password }) => {
  try {
    dispatch({
      type: LOGIN_REQUEST,
    });

    const res = await fetch(`${process.env.REACT_APP_AUTH_API}/admin/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const response = await res.json();
    const { token } = response;

    if (token) {
      const res2 = await fetch(
        // `${process.env.REACT_APP_AUTH_API}/service-group/all`,
        `${process.env.REACT_APP_AUTH_API}/admin/permissions`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const response = await res2.json();
      const { serviceGroups } = response;

      if (serviceGroups?.length) {
        const formatedServices = serviceGroups?.map((item) => ({
          action: item.action,
          serviceNameId: item.serviceNameId,
          serviceName: item.serviceName?.name,
        }));

        localStorage.setItem("authToken", token);
        localStorage.setItem("services", JSON.stringify(formatedServices));

        dispatch({
          type: LOGIN_SUCCESS,
          payload: { ...response },
        });

        responseNotification(
          response?.message?.replace("Operation", "Login"),
          "success"
        );
        window.location.href = `${process.env.PUBLIC_URL}/`;

        return true;
      } else {
        const formatedServices = serviceGroups?.map((item) => ({
          action: item.action,
          serviceNameId: item.serviceNameId,
          serviceName: item.serviceName?.name,
        }));

        localStorage.setItem("authToken", token);
        localStorage.setItem("services", JSON.stringify(formatedServices));

        dispatch({
          type: LOGIN_SUCCESS,
          payload: { ...response },
        });

        responseNotification(
          response?.message?.replace("Operation", "Login"),
          "success"
        );
        window.location.href = `${process.env.PUBLIC_URL}/`;

        return true;
      }
    } else {
      responseNotification(response?.message, "error");
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};
